// extracted by mini-css-extract-plugin
export default {"audioIcon":"VoiceIcon_audioIcon__EiobU"};